import { Switch } from 'antd';
import { useState, useEffect } from 'react';

const SwitchCOD = (props) => {

    const [selectedCOD, setSelectedCOD] = useState([]);

    useEffect(() => {
        setSelectedCOD(false);
    }, []);

    function onChange(checked) {
        setSelectedCOD(checked)
      }
      
    props.onChange(selectedCOD);

    return ( 
        <div>
            <Switch defaultChecked={false} style={{ fontSize: '15px' }} checkedChildren="รวมทุกสาเหตุ" unCheckedChildren="จำแนกรายสาเหตุ" 
            onChange={onChange}/>
        </div>

     );
}
 
export default SwitchCOD;